import paymentType from "./paymentInstrumentTypes";

const initialState = {
  isLoading: false,
  filtering: false,
  searching: false,
  downloading: false,
  creating: false,
  deleting: false,
  allProviders: {},
  myPaymentInstruments: {},
  singlePayment: {},
  allPayments: {},
};

export default function paymentInstrumentReducer(state = initialState, action) {
  switch (action.type) {
    case paymentType.LOADING_PAYMENT:
      return {
        ...state,
        isLoading: action.payLoad,
      };
    case paymentType.LOADING_SEARCH:
      return {
        ...state,
        searching: action.payLoad,
      };
    case paymentType.DOWNLOADING:
      return {
        ...state,
        downloading: action.payLoad,
      };
    case paymentType.CREATING:
      return {
        ...state,
        creating: action.payLoad,
      };
    case paymentType.DELETING:
      return {
        ...state,
        deleting: action.payLoad,
      };
    case paymentType.FILTERING_PAYMENT:
      return {
        ...state,
        filtering: action.payLoad,
      };

    case paymentType.ALL_PAYMENT_PROVIDERS:
      return {
        ...state,
        allProviders: action.payLoad?.data,
      };

    case paymentType.MY_PAYMENT_INSTRUMENT:
      return {
        ...state,
        myPaymentInstruments: action.payLoad?.data,
      };

    case paymentType.SINGLE_PAYMENT:
      return {
        ...state,
        singlePayment: action.payLoad?.data,
      };

    case paymentType.FILTER_PAYMENT:
      return {
        ...state,
        allPayments: action.payLoad?.data,
      };

    default:
      return state;
  }
}
